import styled from 'styled-components';
import { breakpointLG } from '../styles/breakpoints';
export const Wrapper = styled.div `
  display: flex;

  @media (min-width: ${breakpointLG}) {
    display: none;
  }

  .iconButton {
    margin-right: -8px;
  }
`;
//# sourceMappingURL=styles.js.map